import { BsChevronRight } from 'react-icons/bs';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';
import tailwindConfig from '../../../../tailwind.config';
import HotelSearchSelectOption from '../../../../types/HotelSearchSelectOption';
import Property from '../Icons/Property';
import Location from '../Icons/Location';

type Props = {
  option: HotelSearchSelectOption;
  isSelected: boolean;
  isLocaleJA: boolean;
  onClick: () => void;
};

const SearchOption = ({ option, isSelected, isLocaleJA, onClick }: Props) => {
  const { t } = useTranslation('common');

  const getDesc = () => {
    switch (option.type) {
      case 'city':
        return isLocaleJA ? option.prefecture?.ja : option.prefecture?.en;
      case 'prefecture':
        return t('prefecture');
      case 'property':
        return isLocaleJA
          ? `${option.prefecture?.ja}, ${option.prefectureGroup?.ja}`
          : `${option.prefecture?.en}, ${option.prefectureGroup?.en}`;
      default:
        return '';
    }
  };

  return (
    <button
      key={option.value}
      type="button"
      onClick={onClick}
      className="flex h-14 w-full items-center justify-between border-b  border-gray-50 p-4"
    >
      <div className="flex items-center gap-4 text-regular">
        <div className="rounded-md bg-gray-50 p-2">
          {option.type === 'property' ? (
            <Property size={20} color={tailwindConfig.theme.colors.gray[400]} />
          ) : (
            <Location size={20} color={tailwindConfig.theme.colors.gray[400]} />
          )}
        </div>

        <div className="flex flex-col items-start">
          <span className="line-clamp-1 text-start hover:underline">
            {isLocaleJA ? option.label.ja : option.label.en}
          </span>
          <span className={classNames('text-xs capitalize', !isSelected && 'text-gray-500')}>
            {getDesc()}
          </span>
        </div>
      </div>
      <BsChevronRight className="size-3 stroke-2 text-orange-700" />
    </button>
  );
};

export default SearchOption;
